exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label[data-v-a88b6660]::before {\n    background-color: #adb5bd !important;\n    border: 1px solid #adb5bd !important;\n}\n\n", ""]);

// exports
